module.exports = __webpack_public_path__ + "static/media/quindio-39.889b5517.jpg";